import { MDBCol, MDBIcon, MDBRow } from 'mdb-react-ui-kit'
import React from 'react'
import ScrollTo from "react-scroll-into-view";
import ImageBlock from './ImageBlock';
import { motion } from "framer-motion";

const SectionFive = ({sectionId, sectionSelector, sectionImage}) => {
  return (
    <MDBRow id={sectionId} className="row d-flex justify-content-center align-items-center">
        <MDBCol className="col-sm-12 col-md-6 text-center d-flex flex-column justify-content-center align-items-center align-self-stretch mb-0 section-bg-yellow p-5">
            IMPERDIET DUI
            <motion.div initial={{ opacity: 0, x:-200 }} whileInView={{  opacity: 1, x:0 }}  transition={{ delay: 0.35 }} >
                <h2 className="display-2 my-4 section-font"><strong>LECTUS URNA</strong></h2>
            </motion.div>
            <h4>Sem astrum tortor consequat porta. Ornare arcu odio ut sem nulla pharetra. Sed pulvinar quam lacus. Ut civitas integer vitae justo eget magna fermentum iaculis.</h4>
            <ScrollTo selector={sectionSelector}>
                <MDBIcon fas icon="arrow-circle-down" size='4x' className="section-icon my-3" />
            </ScrollTo> 
        </MDBCol>
        <ImageBlock myImage={sectionImage} />
      </MDBRow>
  )
}

export default SectionFive
